import styled from 'styled-components';
export const StyledLiveHead = styled.div`
  background-color: ${(props) => props.theme.liveHead_BG} !important;
  color: ${(props) => props.theme.liveHead_text} !important;
`;

export const StyledLiveTimer = styled.span`
  background-color: ${(props) => props.theme.liveTimer_BG} !important;
  color: ${(props) => props.theme.liveTimer_text} !important;
`;

export const StyledLiveFullTime = styled.span`
  color: ${(props) => props.theme.liveFT_text} !important;
`;

export const StyledLiveHeading = styled.span`
  background-color: ${(props) => props.theme.liveHeading_BG} !important;
  color: ${(props) => props.theme.liveHeading_text} !important;
`;